import React from "react";
import { createPortal } from "react-dom";
import LoaderIcon from "@/assets/images/page-loader.svg?react";

const Loader = (): React.ReactElement => {
  return createPortal(
    <div
      data-testid="global-loader-overlay"
      aria-live="polite"
      aria-label="Loading"
      className="backdrop-blur-[5px] min-h-screen flex items-center justify-center w-screen fixed inset-0 z-[9999] bg-background/50 pointer-events-auto"
    >
      <div data-testid="global-loader-spinner" className="size-18">
        <LoaderIcon
          data-testid="global-loader-icon"
          aria-hidden="true"
          style={{ color: "var(--primary)" }}
        />
      </div>
    </div>,
    document.body,
  );
};

export default Loader;
